export default __webpack_public_path__ + "static/media/quick_order.c6cc2a66.svg";